import {
  SellerGroupPermissions,
  SellerGroupUser,
} from '@seller-hermes/features/seller-group';
import { useStoreState } from '@seller-hermes/hooks/easy-peasy';

export const userHasAnyOfThesePermissions = (
  permissions: Array<keyof SellerGroupPermissions>,
  user: SellerGroupUser
): boolean => {
  if (user.type !== 'USER') return true;
  return permissions.some((permission) => user.role[permission]);
};
export const userHasAllOfThesePermissions = (
  permissions: Array<keyof SellerGroupPermissions>,
  user: SellerGroupUser
): boolean => {
  if (user.type !== 'USER') return true;
  return permissions.every((permission) => user.role[permission]);
};

export const useUserHasAnyOfThesePermissions = (
  permissions: Array<keyof SellerGroupPermissions>
) => {
  const user = useStoreState((s) => s.login.sellerGroupUser.user);
  if (!user) return false;

  return userHasAnyOfThesePermissions(permissions, user);
};

export const useIsUserInternal = () => {
  const user = useStoreState((s) => s.login.sellerGroupUser.user);
  if (!user) return false;

  return user.type === 'INTERNAL';
};
